import { ButtonIcon, Table, TableCell, TableRow } from '@/ui'
import { useTranslation } from 'react-i18next'
import { Plus, Trash } from '@/icons'
import { useState } from 'react'
import { CampaignEventType, MathExpression } from '@/api/dashboard'
import { Button, Edit03, Modal, ModalContent, ModalFooter, ModalProps, ModalTitle, useModal } from '@dashboard/ui'
import { EditMathExprModal } from '@/expr/EditMathExprModal'

export interface EditVarsListModalProps extends Omit<ModalProps, 'onChange'> {
  onChange: (value: MathExpression[]) => void
  value: MathExpression[]
  campaignType?: CampaignEventType | string
}

export const EditVarsListModal = (props: EditVarsListModalProps) => {
  const { t } = useTranslation()
  const [items, setItems] = useState<MathExpression[]>(props.value || [])

  const openVarModal = useModal<{ value?: MathExpression }>(props1 => (
    <EditMathExprModal
      {...props1}
      campaignType={props.campaignType}
      onChange={v => {
        if (v.name) {
          const existingIndex = items.findIndex(item => item.name === v.name)
          if (existingIndex !== -1) {
            items[existingIndex] = v
          } else {
            items.push(v)
          }
        }
        setItems([...items])
      }}
    />
  ))

  const saveClick = () => {
    props.onChange(items)
    props.onClose?.()
  }

  const onRemoveItem = (deleting: MathExpression) => {
    const newItems = items.filter(item => item.name !== deleting.name)
    setItems(newItems)
  }

  return (
    <Modal onResize={() => {}} onClose={props.onClose}>
      <ModalTitle className="flex w-full flex-row items-center">{t('campaign.attr-menu.variables')}</ModalTitle>

      <ModalContent>
        {items.length > 0 && (
          <Table className="mt-3 rounded-sm border border-border-secondary">
            {items.map(item => (
              <TableRow key={item.name}>
                <TableCell>{item.name}</TableCell>

                <TableCell width={42}>
                  <ButtonIcon variant="outline" size="sm" onClick={() => openVarModal({ value: item })}>
                    <Edit03 />
                  </ButtonIcon>
                </TableCell>
                <TableCell width={42}>
                  <ButtonIcon variant="outline" color="danger" size="sm" onClick={() => onRemoveItem(item)}>
                    <Trash />
                  </ButtonIcon>
                </TableCell>
              </TableRow>
            ))}
          </Table>
        )}
      </ModalContent>

      <ModalFooter>
        <Button variant={'outline'} size={'sm'} color="secondary" onClick={() => openVarModal()} className="mr-auto">
          <Plus size={14} />
        </Button>
        <Button variant="outline" onClick={props.onClose}>
          {t('Cancel')}
        </Button>
        <Button variant="default" onClick={saveClick}>
          {t('Apply')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
